<template>
  <v-content id="channel-names-content">
    <v-card>
      <v-card-title id="channel-names-header" class="white--text" primary-title>
        <h3 class="headline mb-0">YouTubeチャンネル名一覧</h3>
      </v-card-title>
      <v-card-actions>
        <v-select id="grad-select" v-model="grad_values" :items="grad_items" attach chips label="" multiple></v-select>
      </v-card-actions>
      <div v-for="(livers, grad) in typedLivers" :key="grad">
        <v-card-text v-if="isSelectedGrad(grad)">
          <div v-for="liver in livers" :key="liver.id">{{findChannelName(liver.id)}}</div>
        </v-card-text>
      </div>
    </v-card>

    <v-dialog v-model="isLoading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-title color="white">
          loading...
        </v-card-title>
        <v-progress-linear indeterminate color="cyan"></v-progress-linear>
      </v-card>
    </v-dialog>
  </v-content>
</template>

<style scoped>
  #channel-names-content {
    padding-top: 0px !important;
    padding-left: 0px !important;
  }

  #channel-names-header {
    background-color: #314B6E;
    border-color: #314B6E;
  }

  #grad-select {
    margin: 0px 16px;
  }
</style>

<script>
import api from '@/util/api.js';
import store from '@/util/store.js'
import { grad } from '@/util/config.js'

  export default {
    data: () => ({
      showYoutubeDialog: false,
      selectedSite: null,
      isLoading: false,
      names: [],
      grad_values: [],
      grad_items: [],
      page: 0
    }),

    props: {
    },

    created() {
      initialize(this);
    },

    mounted() {
    },

    computed: {
      typedLivers: function() {
        return store.state.livers.reduce((acc, liver) => {
          if(!acc[grad[liver.graduation]]) {
            acc[grad[liver.graduation]] = [];
          }
          acc[grad[liver.graduation]].push(liver);
          return acc;
        }, {});
      }
    },

    methods: {
      openSite: function(site) {
        if(site.type == "Youtube") {
          this.selectedSite = site;
          this.showYoutubeDialog = true;
        } else {
          window.open(site.url, "_blank")
        }
      },
      findChannelName(id) {
        let name = this.names.find(item => item.id == id);
        return name && name.name;
      },
      isSelectedGrad(grad) {
        return this.grad_values.find(item => item == grad);
      },
      open: url => window.open(url, "_blank")
    }
  }

  function initialize(app) {
    app.grad_values = Object.keys(app.typedLivers);
    app.grad_items = Object.keys(app.typedLivers);
    app.isLoading = true;
    api.get('/youtube/names').then(res => {
      app.names = res.data;
      app.isLoading = false;
    }).catch(e => {
      console.log(e);
      app.isLoading = false;
    });
  }
</script>
